import Swiper from 'swiper/bundle';

jQuery(document).ready(function ($) {
  new Swiper('.image-slider__slider', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1.1,
    spaceBetween: 8,
    centeredSlides: true,
    navigation: {
      nextEl: '.image-slider__button-next',
      prevEl: '.image-slider__button-prev',
    },
    breakpoints: {
      // screen width >= 480px
      480: {
        spaceBetween: 20,
        slidesPerView: 1.2,
      },
    }
  });
});